// extracted by mini-css-extract-plugin
module.exports = {"analysis":"CSAnalysis_analysis__1b9wX","sides":"CSAnalysis_sides__11gpc","closing":"CSAnalysis_closing__XHkNw","report":"CSAnalysis_report__ztQM-"};